import React from "react";
import Modal from "../../Modal/Modal";
import './DiffModal.scss';
import * as Diff from "diff";

interface Props {
    left: string
    right: string;
    title?: string;
    onClose: () => void;
    leftLabel?: string;
    rightLabel?: string;
}

class DiffModal extends React.Component<Props, { isOpen: boolean }> {

    constructor(props: Props) {
        super(props);

        this.state = {
            isOpen: true
        };

        this.close = this.close.bind(this);
    }

    close(): void {
        this.setState({ isOpen: false });
        this.props.onClose();
    }

    getContent(left: string, right: string): JSX.Element {


        const buildParts = (value: string, htmlElements: JSX.Element[], className: string) => {

            const keywords = ['OR', 'AND', 'ELSE IF', 'THEN', 'ELSE'];

            let statement = '';

            value.split(' ').forEach((subPart) => {

                if (keywords.includes(subPart)) {
                    if (statement) {
                        htmlElements.push(<span key={htmlElements.length} className={className} >{statement}</span>);
                    }
                    buildKeyword(htmlElements, subPart, className);
                    statement = ''
                }
                else if (subPart) {
                    statement += ' ';
                    statement += subPart;
                }
            });

            htmlElements.push(<span key={htmlElements.length} className={className} >{statement}</span>);
        }

        const buildKeyword = (htmlElements: JSX.Element[], keyword: string, className: string) => {

            htmlElements.push(<br key={htmlElements.length}></br>);
            if (keyword === 'ELSE IF' || keyword === 'ELSE') {
                htmlElements.push(<br key={htmlElements.length}></br>);
            }

            htmlElements.push(<span key={htmlElements.length} className={className} >{keyword}</span>);
            if (keyword === 'OR' || keyword === 'AND') {
                htmlElements.push(<br key={htmlElements.length}></br>);
            }
        }

        const prepareHtml = (value: string, className: string, htmlElements: JSX.Element[]) => {

            let elseIfs = value.split('ELSE IF');

            for (var i = 0; i < elseIfs.length; i++) {

                let statement = elseIfs[i];

                buildParts(statement, htmlElements, className);
                if (i < elseIfs.length - 1) {
                    buildKeyword(htmlElements, 'ELSE IF', className);
                }
            }
        }

        let diff = Diff.diffWords(left || '', right);

        let leftParts: JSX.Element[] = [];
        let rightParts: JSX.Element[] = [];

        diff.forEach((part) => {

            part.value = part.value.replaceAll('\r\n', ' ');

            if (part.removed) {
                prepareHtml(part.value, 'margin-0 color-red', leftParts);
            }
            else if (part.added) {
                prepareHtml(part.value, `color-green margin-0`, rightParts);
            }
            else {
                prepareHtml(part.value, 'margin-0', leftParts);
                prepareHtml(part.value, `margin-0`, rightParts);
            }
        });

        let beforeContent = React.createElement("div", { className: 'padding-10px' }, leftParts);

        let afterContent = React.createElement("div", { className: 'padding-10px' }, rightParts);

        return <div className='display-flex width-100-percents justify-content-between'>
            <div key={1} className='width-49-percents'>
                <h5>{`${this.props.leftLabel || 'Before'}`}</h5>
                {beforeContent}
            </div>
            <div className='width-49-percents'>
                <h5>{`${this.props.rightLabel || 'After'}`}</h5>
                {afterContent}
            </div>
        </div>;
    }

    render(): JSX.Element {
        return (
            <>
                <Modal state={{ isOpen: this.state.isOpen, title: `${this.props.title || 'Diff'}`, error: '' }} close={this.close} size='full-width'>
                    {this.getContent(this.props.left, this.props.right)}
                </Modal>
            </>
        );
    }
}

export default DiffModal;